"use strict";
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.startAnimation = exports.animationLoop = void 0;
var dom = __importStar(require("./domElements.ts"));
var config = __importStar(require("./config.ts"));
var state = __importStar(require("./state.ts"));
var canvasManager_ts_1 = require("./canvasManager.ts");
var mockCursorManager_ts_1 = require("./mockCursorManager.ts");
var imageManager_ts_1 = require("./imageManager.ts");
function animationLoop() {
    var now = performance.now();
    var currentFlowerGridCellSize = config.FLOWER_GRID_CELL_WIDTH_IN_SEGMENTS * state.calculatedSegmentSize;
    if (state.needsImageReload) {
        state.setNeedsImageReload(false);
        var imageUrl = state.isMobileLayout
            ? config.MOBILE_IMAGE_URL
            : config.DESKTOP_IMAGE_URL;
        (0, imageManager_ts_1.loadImageFromUrl)(imageUrl);
        // Return early, as loadImageFromUrl will trigger its own animation frame
        return;
    }
    if (config.numberOfMockUsers > 0 &&
        now >= state.initialCursorVisibilityDelayEndTime) {
        (0, mockCursorManager_ts_1.updateMockUserCursors)(now, currentFlowerGridCellSize);
        (0, mockCursorManager_ts_1.updateMockCursorProximities)();
        (0, mockCursorManager_ts_1.interpolateMockCursorPositions)(now, currentFlowerGridCellSize);
    }
    var logicalGridValid = state.logicalGridCells &&
        state.logicalGridCells.totalWidthPx > 0 &&
        state.logicalGridCells.totalHeightPx > 0;
    var sweepConditionTarget = state.loadedImage &&
        (state.permanentFlowers.length > 0 || state.activeEffects.length > 0) &&
        logicalGridValid;
    if (sweepConditionTarget) {
        var sweepStartY = state.logicalGridCells.offsetY;
        var sweepableHeight = state.logicalGridCells.totalHeightPx;
        if (!state.isSweeping) {
            if (now >= state.sweepPauseEndTime) {
                state.setIsSweeping(true);
                state.setSweepStartTime(now);
                state.setSweepLineY(sweepStartY);
            }
        }
        else {
            var elapsedSweepTime = now - state.sweepStartTime;
            if (sweepableHeight > 0 && elapsedSweepTime < config.SWEEP_DURATION_MS) {
                var currentSweepProgress = elapsedSweepTime / config.SWEEP_DURATION_MS;
                var sweepLineAbsoluteY = sweepStartY + currentSweepProgress * sweepableHeight;
                state.setSweepLineY(Math.min(sweepLineAbsoluteY, sweepStartY + sweepableHeight));
            }
            else {
                state.setIsSweeping(false);
                state.setSweepPauseEndTime(now + config.SWEEP_PAUSE_DURATION_MS);
                state.setSweepLineY(-1);
                state.setPermanentFlowers([]);
                state.setActiveEffects([]);
                state.setPostSweepFlowerDelayActiveUntil(now + state.postSweepFlowerDelayDuration);
                if (state.loadedImage) {
                    (0, canvasManager_ts_1.drawImageToBaseLayer)(state.loadedImage);
                }
            }
        }
    }
    else {
        if (state.isSweeping) {
            state.setIsSweeping(false);
            state.setSweepLineY(-1);
            state.setSweepPauseEndTime(now + config.SWEEP_PAUSE_DURATION_MS);
        }
        else {
            if (now > state.sweepPauseEndTime &&
                (state.loadedImage ||
                    state.permanentFlowers.length > 0 ||
                    state.activeEffects.length > 0) &&
                logicalGridValid) {
                state.setSweepPauseEndTime(now + config.SWEEP_PAUSE_DURATION_MS);
            }
        }
    }
    var nextFrameActiveEffects = [];
    state.activeEffects.forEach(function (effect) {
        var elapsedTime = now - effect.startTime;
        var naturalAnimationCompletionTime = (effect.maxRingIndex + 1) * config.ANIMATION_STEP_DURATION;
        if (elapsedTime < naturalAnimationCompletionTime) {
            nextFrameActiveEffects.push(effect);
        }
        else {
            if (!state.isSweeping) {
                if (!state.permanentFlowers.some(function (pf) { return pf.id === effect.id; })) {
                    // Colors are now determined and stored in effect.patternSegments by drawPatternedShape
                    // So, we can directly use effect.patternSegments for the permanent flower.
                    state.permanentFlowers.push({
                        id: effect.id,
                        clickGridX: effect.clickGridX,
                        clickGridY: effect.clickGridY,
                        maxRingIndex: effect.maxRingIndex,
                        patternStyle: effect.patternStyle,
                        patternSegments: effect.patternSegments,
                        isMockUserFlower: effect.isMockUserFlower,
                        isUserClickFlower: effect.isUserClickFlower,
                        flowerProximityInfluence: effect.flowerProximityInfluence,
                        effectivePalette: effect.effectivePalette
                    });
                }
            }
        }
    });
    state.setActiveEffects(nextFrameActiveEffects);
    (0, canvasManager_ts_1.renderCanvas)();
    var needsContinuousAnimation = (state.loadedImage &&
        (state.isSweeping || now < state.sweepPauseEndTime)) ||
        state.activeEffects.length > 0 ||
        state.currentHoveredPrimaryCell ||
        state.currentHoveredMirroredCell ||
        state.currentHoveredMirrorXCell ||
        state.currentHoveredMirrorYCell ||
        (config.numberOfMockUsers > 0 &&
            state.mockUserCursors.length > 0 &&
            now >= state.initialCursorVisibilityDelayEndTime) ||
        (state.currentHoveredPrimaryCell &&
            config.numberOfMockUsers > 0 &&
            state.mockUserCursors.length > 0 &&
            now >= state.initialCursorVisibilityDelayEndTime) ||
        state.enableSymmetricalSpecialColor || // Keep animating if this option might change visuals
        now < state.initialCursorVisibilityDelayEndTime || // Keep animating if cursor visibility delay is active
        now < state.initialFlowerCreationDelayEndTime; // Keep animating if flower creation delay is active
    if (needsContinuousAnimation) {
        state.setAnimationFrameId(requestAnimationFrame(animationLoop));
    }
    else {
        state.setAnimationFrameId(null);
        (0, canvasManager_ts_1.renderCanvas)();
    }
}
exports.animationLoop = animationLoop;
function startAnimation() {
    if (!dom.canvas || !dom.ctx)
        return;
    var now = performance.now();
    var needsImmediateAnimation = state.needsImageReload || // Add this condition
        (state.loadedImage &&
            (state.isSweeping || now < state.sweepPauseEndTime)) ||
        state.activeEffects.length > 0 ||
        state.currentHoveredPrimaryCell ||
        state.currentHoveredMirroredCell ||
        state.currentHoveredMirrorXCell ||
        state.currentHoveredMirrorYCell ||
        (config.numberOfMockUsers > 0 &&
            state.mockUserCursors.length > 0 &&
            now >= state.initialCursorVisibilityDelayEndTime) ||
        (state.currentHoveredPrimaryCell &&
            config.numberOfMockUsers > 0 &&
            state.mockUserCursors.length > 0 &&
            now >= state.initialCursorVisibilityDelayEndTime) ||
        state.enableSymmetricalSpecialColor ||
        now < state.initialCursorVisibilityDelayEndTime || // Keep animating if cursor visibility delay is active
        now < state.initialFlowerCreationDelayEndTime; // Keep animating if flower creation delay is active
    if (state.animationFrameId === null && needsImmediateAnimation) {
        state.setAnimationFrameId(requestAnimationFrame(animationLoop));
    }
    else if (state.animationFrameId !== null && !needsImmediateAnimation) {
        (0, canvasManager_ts_1.renderCanvas)();
    }
    else if (state.animationFrameId === null && !needsImmediateAnimation) {
        (0, canvasManager_ts_1.renderCanvas)();
    }
}
exports.startAnimation = startAnimation;
